import React from 'react';

export const ToiletSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 32 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.0002 16V18H11.2932C10.4262 18 9.45816 18.896 9.13216 20L5.59016 32C5.26416 33.104 5.89616 34 7.00016 34H25.0002C26.1042 34 27.0002 33.104 27.0002 32V22C27.0002 20.139 28.2782 18.588 30.0002 18.142V16H24.0002Z" fill={color} />
        <path d="M20 17.875C20 21.396 15.522 25 10 25C4.477 25 0 21.396 0 17.875C0 16 0.833 16 10 16C19.166 16 20 16 20 17.875ZM23 15C23 15.553 22.486 16 21.85 16H1.15C0.515 16 0 15.553 0 15C0 14.447 0.515 14 1.15 14H21.85C22.486 14 23 14.447 23 15Z" fill={color} />
        <path d="M32 2C32 0.896 31.104 0 30 0H22C20.896 0 20 0.896 20 2V16C20 17.104 20.896 18 22 18H30C31.104 18 32 17.104 32 16V2Z" fill={color} />
        <path d="M20 2H32V4H20V2Z" fill={color} />
        <path d="M23 19C23 19.553 22.553 20 22 20H1C0.448 20 0 19.553 0 19C0 18.447 0.448 18 1 18H22C22.553 18 23 18.447 23 19Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 32 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.0002 18V20H11.2932C10.4262 20 9.45816 20.896 9.13216 22L5.59016 34C5.26416 35.104 5.89616 36 7.00016 36H25.0002C26.1042 36 27.0002 35.104 27.0002 34V24C27.0002 22.139 28.2782 20.588 30.0002 20.142V18H24.0002Z" fill="#AAB8C2" />
      <path d="M20 21.875C20 25.396 15.522 29 10 29C4.477 29 0 25.396 0 21.875C0 20 0.833 20 10 20C19.166 20 20 20 20 21.875ZM23 19C23 19.553 22.486 20 21.85 20H1.15C0.515 20 0 19.553 0 19C0 18.447 0.515 18 1.15 18H21.85C22.486 18 23 18.447 23 19Z" fill="#E1E8ED" />
      <path d="M16 16H4C2.896 16 2 16.896 2 18H18C18 16.896 17.104 16 16 16ZM18 0V18C19.104 18 20 16.993 20 15.75V2.25C20 1.007 19.104 0 18 0Z" fill="#99AAB5" />
      <path d="M32 4C32 2.896 31.104 2 30 2H22C20.896 2 20 2.896 20 4V18C20 19.104 20.896 20 22 20H30C31.104 20 32 19.104 32 18V4Z" fill="#E1E8ED" />
      <path d="M18 18C19.1046 18 20 17.1046 20 16C20 14.8954 19.1046 14 18 14C16.8954 14 16 14.8954 16 16C16 17.1046 16.8954 18 18 18Z" fill="#CCD6DD" />
      <path d="M20 4H32V6H20V4Z" fill="#CCD6DD" />
      <path d="M23 21C23 21.553 22.553 22 22 22H1C0.448 22 0 21.553 0 21C0 20.447 0.448 20 1 20H22C22.553 20 23 20.447 23 21Z" fill="#AAB8C2" />
    </svg>
  )
}